import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { queryExecutor } from '@/_core/cqrs';
import { RefreshLastUpdatedOnCardsQuery, RefreshLastUpdatedOnCardsResult } from '../../api/queries';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class RefreshLastUpdatedOnCards extends Action<StorymapState> {
    public static ACTION_TYPE = 'RefreshLastUpdatedOnCards';

    public _res: RefreshLastUpdatedOnCardsResult;

    public constructor() {
        super(RefreshLastUpdatedOnCards.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: RefreshLastUpdatedOnCards): Promise<boolean> => {
    action._res = await queryExecutor.executeQuery(new RefreshLastUpdatedOnCardsQuery(state.id));
    return true;
};

const reducer = (state: StorymapState, action: RefreshLastUpdatedOnCards): void => {
    const activitiesById = new Map<string, any>(state.activities.map((c) => [c.id, c]));
    action._res.Activities.forEach(x => {
        const card = activitiesById.get(x.Id);
        if (card != null) {
            card.lastUpdatedAt = new Date(x.LastUpdatedAt);
            card.lastUpdatedByUserId = x.LastUpdatedByUserId;
        }
    });
    const tasksById = new Map<string, any>(state.tasks.map((c) => [c.id, c]));
    action._res.Tasks.forEach(x => {
        const card = tasksById.get(x.Id);
        if (card != null) {
            card.lastUpdatedAt = new Date(x.LastUpdatedAt);
            card.lastUpdatedByUserId = x.LastUpdatedByUserId;
        }
    });
    const subtasksById = new Map<string, any>(state.subtasks.map((c) => [c.id, c]));
    action._res.Subtasks.forEach(x => {
        const card = subtasksById.get(x.Id);
        if (card != null) {
            card.lastUpdatedAt = new Date(x.LastUpdatedAt);
            card.lastUpdatedByUserId = x.LastUpdatedByUserId;
        }
    });
};

//@ts-ignore
registerMiddleware(RefreshLastUpdatedOnCards.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(RefreshLastUpdatedOnCards.ACTION_TYPE, reducer);